import { Container } from '@mui/material';
import TopBar from './TopBar';
import Footer from './Footer';

const PageLayout = ({ children, hideAuth = false }) => (
  <>
    <TopBar hideAuth={hideAuth} />
    <Container maxWidth="xl" sx={{ minHeight: '80vh', px: { xs: 2, sm: 4 }, py: { xs: 3, md: 6 } }}>
      {children}
    </Container>
    <Footer />
  </>
);

export default PageLayout; 